import combineApiURL from 'utils/combineApiURL';
import { CheckVehicles, Ticket } from './BCResult.types';

export const getImageSrc = (filename: string) =>
  `${combineApiURL()}/photo/${filename.slice(0, 2)}/${filename}`;

export const getEmptyVehiclesTableString = (
  tickets: Ticket[]
): CheckVehicles => ({
  depot_number: '',
  route_short_name: '',
  driver_raport: 0,
  kickout: 0,
  OVDdeliver: 0,
  sell_tickets: tickets.map(({ id }) => ({
    ticket_id: id,
    count: 0,
  })),
  table_number: '',
  take_tickets: [
    {
      ticket_id: 'sk',
      count: 0,
    },
    {
      count: 0,
      ticket_id: 'vesb',
    },
    {
      ticket_id: 'other_leg',
      count: 0,
    },
    {
      ticket_id: 'other_not_leg',
      count: 0,
    },
  ],
});
